import { EnrichedFileInformation } from '../interfaces/enriched-fileinformation.interface';
import { BlockBlobClient } from '@azure/storage-blob';

export class UploadHelper {
	static async uploadFiles(files: EnrichedFileInformation[], loadedFiles: File[]) {
		const blocksize = 4 * 1024 * 1024;
		for(let i = 0; i < files.length; i++) {
			const loadedFile = loadedFiles[i];

			const blockBlobClient = new BlockBlobClient(files[i].downloadUrl);
			// this automatically chunks files larger than 256MB for performance
			await blockBlobClient.uploadData(loadedFile, {
				maxSingleShotSize: blocksize,
				blockSize: blocksize,
				onProgress: (progress) => {
					const percent = Math.round((progress.loadedBytes / loadedFile.size) * 100);
					console.log(`Upload progress: ${percent}%`);
				}
			});
		}
	}
}
